
import { Component, Vue, Prop } from 'vue-property-decorator';
import { RateAlertSetting, RateAlertInequalityType } from 'ah-api-gateways';
import RateAlertSettingsEditModal from '@/app/components/settings/notifications/RateAlertSettingsEditModal.vue';
import { useSettingsStore } from '@/app/store/settingsModule';

@Component({
  components: {
    RateAlertSettingsEditModal,
  },
})
export default class SingleNotificationRateAlertSettingEditForm extends Vue {
  @Prop({ required: true }) rateAlert!: RateAlertSetting;

  @Prop({ default: false }) readonly!: boolean | string;

  get rateAlertFromCurrency() {
    return this.rateAlert.currencyPair.substr(0, 3);
  }

  get rateAlertToCurrency() {
    return this.rateAlert.currencyPair.substr(3);
  }

  get rateAlertRate() {
    return this.rateAlert.rate.toFixed(this.settingsStore.ratePrecision);
  }

  get rateAlertInequalitySymbol() {
    return this.rateAlert.inequality === RateAlertInequalityType.HIGHER_THAN ? '>' : '<';
  }

  get settingsStore() {
    return useSettingsStore();
  }
}
